"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetRewardQualificationToUser = exports.assetRewardToUser = exports.AssetRewardQualificationTrigger = exports.AssetRewardPromotionType = exports.AssetRewardStatus = void 0;
const asset_redemptions_1 = require("./asset-redemptions");
/**
 * Internal
 */
var AssetRewardStatus;
(function (AssetRewardStatus) {
    AssetRewardStatus["Pending"] = "PENDING";
    AssetRewardStatus["Live"] = "LIVE";
    AssetRewardStatus["Expired"] = "EXPIRED";
    AssetRewardStatus["Disabled"] = "DISABLED";
})(AssetRewardStatus = exports.AssetRewardStatus || (exports.AssetRewardStatus = {}));
var AssetRewardPromotionType;
(function (AssetRewardPromotionType) {
    AssetRewardPromotionType["SignUpBonus"] = "SIGN_UP_BONUS";
    AssetRewardPromotionType["CustomerAction"] = "CUSTOMER_ACTION";
    AssetRewardPromotionType["LearnBonus"] = "LEARN_BONUS";
})(AssetRewardPromotionType = exports.AssetRewardPromotionType || (exports.AssetRewardPromotionType = {}));
var AssetRewardQualificationTrigger;
(function (AssetRewardQualificationTrigger) {
    AssetRewardQualificationTrigger["GreenIdComplete"] = "GREEN_ID_COMPLETE";
    AssetRewardQualificationTrigger["Kyc0Complete"] = "KYC_0_COMPLETE";
    AssetRewardQualificationTrigger["Kyc1Complete"] = "KYC_1_COMPLETE";
    AssetRewardQualificationTrigger["Kyc2Complete"] = "KYC_2_COMPLETE";
    // DepositsComplete = 'DEPOSITS_COMPLETE', // FUTURE STATE
    AssetRewardQualificationTrigger["TradesComplete"] = "TRADES_COMPLETE";
    // RecurringOrdersPlaced = 'RECURRING_ORDERS_PLACED', // FUTURE STATE
    // BundlesPurchased = 'BUNDLES_PURCHASED', // FUTURE STATE
    // MultiFactorEnabled = 'MULTI_FACTOR_ENABLED', // FUTURE STATE
    AssetRewardQualificationTrigger["LearnCourseComplete"] = "LEARN_COURSE_COMPLETE";
})(AssetRewardQualificationTrigger = exports.AssetRewardQualificationTrigger || (exports.AssetRewardQualificationTrigger = {}));
// Map a full asset reward entity to a user asset reward
function assetRewardToUser(assetReward) {
    return {
        id: assetReward.id,
        campaignName: assetReward.campaignName,
        description: assetReward.description,
        promotionType: assetReward.promotionType,
        rewardAssetId: assetReward.rewardAssetId,
        valueAssetId: assetReward.valueAssetId,
        valueAmount: assetReward.valueAmount,
        endDate: assetReward.endDate,
        qualificationPeriod: assetReward.qualificationPeriod,
        status: assetReward.status,
        hasPayout: assetReward.hasPayout,
        redeemablePeriod: assetReward.redeemablePeriod,
        hardEndDate: assetReward.hardEndDate,
        redemptionLimit: assetReward.redemptionLimit,
        redemptions: assetReward.redemptions?.map(asset_redemptions_1.assetRedemptionToUser),
        qualifications: assetReward.qualifications?.map(assetRewardQualificationToUser),
    };
}
exports.assetRewardToUser = assetRewardToUser;
// Map a full asset reward qualification entity to a user asset reward qualification
function assetRewardQualificationToUser(qualification) {
    return {
        trigger: qualification.trigger,
        thresholdAssetId: qualification.thresholdAssetId,
        thresholdAmount: qualification.thresholdAmount,
    };
}
exports.assetRewardQualificationToUser = assetRewardQualificationToUser;
//# sourceMappingURL=asset-rewards.js.map